import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { tenantService } from "../../Services/tenant.service";
import SpinnerLoading from "../../Components/Common/SpinnerLoading";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";

const TenantDetailTab = props => {
  const { t: translator } = useTranslation();
  const { locTab,updateLocTab } = useContext(GlobalContext);

  const [data, setData] = useState();
  const history = useHistory();

  useEffect(() => {
    if (locTab === "tenants") {
      tenantService
        .getById(props.tenantId)
        .then(res => {
          setData(res.data);
        })
        .catch(err => history.push("/error-page/401"));
    }
  }, [locTab]);
  const handleToDetail = () => {
    updateLocTab("tenants");
    history.push(`/tenants/${props.tenantId}`);
  };

  return (
    <>
      {!data && <SpinnerLoading />}
      {data && (
        <div className="col-lg-5">
          <div className="custom-card m-2 mt-5">
            <div className="custom-card-header">
              <h3>
                {data.name}  <span className="button-edit">
                  <span
                    onClick={handleToDetail}
                    title={translator("StoreDetailTab-DetailsIcon")}
                    className="icon icon-information"></span>
                </span>
              </h3>
              <span className="custom-card-subtitle">
                <strong>{translator("Tenant-TenantDetail-OIB")}:</strong>{" "}
                {data.taxNumber}
              </span>
              <hr />
            </div>
            <div className="custom-card-body">
              <p>
                <strong>{translator("Tenant-TenantDetail-Owner")}:</strong>
                {""}
                {data.owner}
              </p>
              <p>
                <span>
                  <strong>{translator("Tenant-TenantDetail-Street")}:</strong>{" "}
                  {data.street} {data.streetNumber}
                  {data.streetNumberExtension}
                </span>
                <br />
                <span>
                  <strong>{translator("Tenant-TenantDetail-City")}:</strong>{" "}
                  {data.postalNumber}, {data.city}
                </span>
                <br />
                <span>
                  <strong>{translator("Tenant-TenantDetail-TaxNote")}:</strong>{" "}
                  {data.taxNote}
                </span>
              </p>

              <p>
                <hr />
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name="fiscalObligation"
                    checked={data.fiscalObligation}
                  />
                  <span className="checkmark"></span>
                </label>
                <span className="Data">
                  {translator("Tenant-TenantDetail-ObligorOfFiscalization")}
                </span>

                <br />
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name="fiscalObligation"
                    checked={data.taxObligation}
                  />
                  <span className="checkmark"></span>
                </label>
                <span className="Data">
                  {translator("Tenant-TenantDetail-TaxLiability")}
                </span>

                <br />
              </p>
            </div>
            <div className="custom-card-footer"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default TenantDetailTab;
